export async function api<T>(ruta: string, init?: RequestInit): Promise<T> {
  const respuesta = await fetch(ruta, {
    ...init,
    headers: init?.body ? { "Content-Type": "application/json", ...init.headers } : init?.headers,
  });
  const datos = await respuesta.json() as T & { error?: string; requiereCambioClave?: boolean };
  if (!respuesta.ok) {
    const fallo = new Error(datos.error || "No fue posible completar la operación.");
    Object.assign(fallo, { status: respuesta.status, requiereCambioClave: datos.requiereCambioClave });
    throw fallo;
  }
  return datos;
}
export const dinero = (centavos: number) => new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(centavos / 100);
export const hoy = () => {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0,10);
};
